<template>
  <a-card size="small" :bordered="false">
    <div class="page-header-index-wide">
      <a-row :gutter="24">
        <a-col :sm="6" :md="6" :xl="6">
          <div>總人數/座位總數:{{ totalPerson }}/{{ totalSeats }},未選座位人數:{{ noAssignPersons }}</div>
        </a-col>
        <a-col justify="end" :sm="18" :md="18" :xl="18">
          <div class="table-operator" style="float: right;">
            <a-button @click="handleAutoRank">一鍵排位</a-button>
            <a-button @click="handleOneClear">一鍵清除</a-button>
            <a-button @click="handleManualRank">手動選座</a-button>
            <a-button @click="handleCancelRank">取消選座</a-button>
            <a-button @click="handleOccupyRank">佔位</a-button>
            <a-button @click="handleLockRank">鎖定</a-button>
            <a-button @click="handleUnlockRank">解鎖</a-button>
            <a-button @click="handleSwapRank">互換座位</a-button>
            <a-button style="margin-left: 8px" icon="download" @click="ExportXls">导出</a-button>
          </div>

        </a-col>
      </a-row>
      <a-row :gutter="24">

        <a-tabs hide-add :active-key="activeKey" @change="handleClickTab">
          <a-tab-pane v-for="pane in FloorAreaList" :key="pane.sysfloorid" :tab="pane.floorname"
            :closable="pane.closable">
            <div :style="{ marginTop: '5px' }">
              <a-radio-group :defaultValue="active" v-model:active="active" @change="handleRadioChange"
                button-style="solid">
                <a-radio-button button-style="solid" v-for="item in pane.children" :value="item.sysareaid"
                  :key="item.sysareaid">
                  {{ item.areaname }}
                </a-radio-button>
              </a-radio-group>
              <a-divider type="vertical" />

              <div class="current-settings" style="margin-left: 100px;">當前設置的座位狀態為:</div>

              <a-radio-group v-model="status" @change="handleRadioStatusChange" button-style="solid">
                <a-radio-button button-style="solid" :value="0" :key="0">
                  可用
                </a-radio-button>
                <a-radio-button button-style="solid" :value="1" :key="1">
                  不可用
                </a-radio-button>
                <a-radio-button button-style="solid" :value="2" :key="2">
                  不可见
                </a-radio-button>
              </a-radio-group>

              <div style="float: right;">
                <!-- <a-button v-if="from === 'VenueList'" type="primary" style="margin-left: 8px"
            >设置座位状态</a-button> -->
                <a-dropdown style="margin-left: 8px">
                  <template #overlay>
                    <a-menu>
                      <a-menu-item key="1" @click="handleAddAreaInfo">新增區域</a-menu-item>
                      <a-menu-item key="2" @click="handleEditAreaInfo">修改區域</a-menu-item>
                      <a-menu-item key="3" @click="handleDeleteAreaInfo">刪除區域</a-menu-item>
                    </a-menu>
                  </template>
                  <a-button>
                    設定區域
                    <a-icon type="down" style="margin-left: 8px" />
                  </a-button>
                </a-dropdown>
              </div>
            </div>
            <div class="main">
              <div class="main-content">
                <div class="select-hbody">
                  <div class="tdbody-line">
                    <!-- @contextmenu.prevent="handleContextMenu($event, pk+1,'col')"  -->
                    <div v-for="(item, pk) in maxColQty" :key="pk" @contextmenu="showMenuCol(pk + 1, 'col')"
                      @click="clickData('rows', maxRowQty, pk)" class="colno"> {{ pk + 1 }}列</div>

                    <div :key="maxColQty">
                      <a-button @click="handleAddCol">
                        新增列
                      </a-button>
                    </div>
                  </div>
                </div>
                <div class="tdbody-coln">
                  <!-- @contextmenu.prevent="handleContextMenu($event, hk+1,'row')" -->
                  <div v-for="(item, hk) in maxRowQty" :key="hk" @contextmenu="showMenuRow(hk + 1, 'row')"
                    @click="clickData('cols', hk, maxColQty)" class="rowno"> {{ hk + 1 }}排</div>

                  <div :key="maxRowQty" @click="handleAddRow"> <a-button style="width: 60px;text-align: center;">
                      新增排
                    </a-button></div>
                </div>
                <!-- @mousedown="down" @mousemove="move" @mouseup="upan" -->
                <div class="select-area" @mousedown="down" @mousemove="move" @mouseup="upan">
                  <div ref="movable" class="move" :style="myStyle"></div>
                  <div v-for="(item, index) in subset" :key="index" class="list">
                    <div v-for="(val, pk) in item" :key="pk" class="oplist">
                      <!-- <div ref="seats" :class="(selected.indexOf((pk + 1) + (index * maxColQty)) > -1) ? 'selected' : ''" class="item">
                    {{ val.remark }} </div> -->

                      <!-- 0--可用/未選 -->
                      <div :ref="'seats_' + pane.sysfloorid" :id="val.sysseatid" v-if="val.status === '0'" class="item "
                        :class="(selected.indexOf((pk + 1) + (index * maxColQty)) > -1) ? 'selected' : ''"
                        :style="{ border: bordersize + val.sgroupcolor }"
                        @contextmenu.prevent="showMenuSignal(val.sysseatid)">
                      </div>

                      <!-- 1--不可用/2--不可見 -->
                      <div :ref="'seats_' + pane.sysfloorid" :id="val.sysseatid"
                        v-else-if="val.status === '1' || val.status === '2'" class="emptyseat"
                        :class="(selected.indexOf((pk + 1) + (index * maxColQty)) > -1) ? 'selected' : ''"
                        @contextmenu.prevent="showMenuSignal(val.sysseatid)">{{ val.remark }}</div>

                      <!-- 3--已選 -->
                      <div :ref="'seats_' + pane.sysfloorid" :id="val.sysseatid" v-else-if="val.status === '3'"
                        class="item green" :style="{ border: bordersize + val.sgroupcolor }"
                        @contextmenu.prevent="showMenuSignal(val.sysseatid)">
                        {{ val.pname }}
                      </div>

                      <!-- 4--佔用 -->
                      <div :ref="'seats_' + pane.sysfloorid" :id="val.sysseatid" v-else-if="val.status === '4'"
                        class="item yellow"
                        :class="(selected.indexOf((pk + 1) + (index * maxColQty)) > -1) ? 'selected' : ''"
                        :style="{ border: bordersize + val.sgroupcolor }"
                        @contextmenu.prevent="showMenuSignal(val.sysseatid)">{{ val.pname }}</div>

                      <!-- 5--鎖定  -->
                      <div :ref="'seats_' + pane.sysfloorid" :id="val.sysseatid" v-else="val.status === '5'"
                        class="item red"
                        :class="(selected.indexOf((pk + 1) + (index * maxColQty)) > -1) ? 'selected' : ''"
                        :style="{ border: bordersize + val.sgroupcolor }"
                        @contextmenu.prevent="showMenuSignal(val.sysseatid)"></div>
                      <!-- 0--可用/未選
                    1--不可用
                    2--不可見
                    3--已選
                    4--佔用
                    5--鎖定 -->


                    </div>
                  </div>
                </div>
                <!-- 通过右击获取到的坐标定位 -->
                <div>

                  <!-- <ul class="context-menu" ref="menu" v-show="visible" :style="{ left: left + 'px', top: top + 'px' }">
                  <li v-for="item in items" :key="item.action" @click="handleClick(item.action)">{{ item.label }}</li>
                </ul>  -->
                  <vue-context-menu style=" margin-left: auto;" :contextMenuData="contextMenuDataRow" @addrow="addrow"
                    @delrow="delrow" />
                  <vue-context-menu :contextMenuData="contextMenuDataCol" @addcol="addcol" @delcol="delcol" />
                  <vue-context-menu :contextMenuData="contextMenuDataSignal" @ManualRank="handleManualRank"
                    @UnlockRank="handleUnlockRank" @LockRank="handleLockRank" @OccupyRank="handleOccupyRank"
                    @CancelRank="handleCancelRank" />
                </div>
              </div>
            </div>
          </a-tab-pane>

          <template #tabBarExtraContent>
            <div style="float: right;">
              <!-- 图片预览 -->
              <ImageView class="imgOfKinds" :imgUrl="sysfloorData.allfiles"></ImageView>
              <a-button style="margin-left: 8px" v-if="from === 'VenueList'" @click="handleEditVenueInfo">
                編輯場館
              </a-button>
              <a-dropdown style="margin-left: 8px">
                <template #overlay>
                  <a-menu>
                    <a-menu-item key="1" @click="handleAddFloorInfo">新增樓層</a-menu-item>
                    <a-menu-item key="2" @click="handleEditFloorInfo">修改樓層</a-menu-item>
                    <a-menu-item key="3" @click="handleDeleteFloorInfo">刪除樓層</a-menu-item>
                  </a-menu>
                </template>
                <a-button>
                  設定樓層
                  <a-icon type="down" style="margin-left: 8px" />
                </a-button>
              </a-dropdown>

            </div>
          </template>
        </a-tabs>
      </a-row>

      <PersonSelectedModal ref="personSelectedModal"> </PersonSelectedModal>
    </div>
    <person-modal ref="modalForm" @ok="modalFormOk"></person-modal>
    <ActivityModal ref="modalFormActivity"></ActivityModal>

    <div>
      <VenueInfoModal ref="venueInfoModal" @ok="refreshVenueName"></VenueInfoModal>
      <FloorModal ref="floorModal" :from="from" @ok="loadData"></FloorModal>
      <AreaModal ref="areaModal" :from="from" @ok="loadData"></AreaModal>
    </div>

    <j-modal ref="personModal" :title="'選擇排位人員'" width="40%" :visible="personModalVisible" @ok="handlePersonFormOk"
      :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }" @cancel="handlePersonFormCancel" cancelText="关闭">
      <template>
        <div>
          <a-row>
            <span>座位信息：{{ selectedseats.map((item) => { return item.seatname }).join(',') }}</span>

          </a-row>
          <a-row>
            <a-select allowClear placeholder="選擇排位人員" style="width: 100%" v-model:value="selectedperson" showSearch
              @popupScroll="handlePopupScroll" @search="handleSearch" :filter-option="filterOption">
              <a-select-option v-for="frontSelect in personNoAssign" :key="frontSelect.value">
                {{ frontSelect.label }}
              </a-select-option>
            </a-select>
          </a-row>
        </div>
      </template>
    </j-modal>

    <j-modal ref="assignrule" :title="'排座規則'" width="40%" :visible="assignruleModalVisible" @ok="handleAssignruleFormOk"
      :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }" @cancel="handleAssignruleFormCancel" cancelText="关闭">
      <template>
        <div>

          <a-row>
            <!-- <j-dict-select-tag type="select" v-model="assign_rule" dictCode="cs_assignrule" /> -->

            <a-radio-group v-model="assign_rule">
              <a-radio :style="radioStyle" v-for="item in assignruleList" :value="item.key" :key="item.key">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-row>
        </div>
      </template>
    </j-modal>

  </a-card>
</template>

<script>
const filterOption = (input, option) => {
  return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

function dataProces(areaData = null, infoList = null) {
  if (!areaData || !infoList) {
    return;
  }
  let showlist = [];
  let subset = [];
  let maxRowQty = 0;
  let maxColQty = 0;
  areaData.forEach((item, index) => {
    infoList.forEach((val, pk) => {
      if (item.sysareaid == val.sysareaid) {
        maxRowQty = item.maxRowQty;
        maxColQty = item.maxColQty;
        showlist.push(val);
      }
    })
  })
  if (showlist.length > 0) {
    for (let i = 0; i < maxRowQty; i++) {
      let attData = [];
      for (let j = 0; j < maxColQty; j++) {
        let data = [];
        data = lineData(i, j, showlist);
        attData.push(data);
      }
      subset.push(attData);
    }
  }
  console.log('座位数据:', subset)
  return subset;
}

function lineData(i = 0, j = 0, data = null) {
  let retData = [];
  data.forEach((val, pk) => {
    if (val.rowno === (i + 1) && val.colno === (j + 1)) {
      retData = val;
      return;
    }
  });
  return retData;
}

import { httpAction, getAction, deleteAction, postAction, downloadFile } from '@/api/manageChooseSeat'
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
import PersonSelectedModal from './PersonSelectedModal.vue'
import PersonModal from '@/views/chooseSeat/Person/modules/PersonModal'
import ActivityModal from './ActivityModal.vue'

import VenueInfoModal from '@/views/chooseSeat/BaseData/Venue/modules/VenueInfoModal.vue'
import FloorModal from '@/views/chooseSeat/BaseData/Venue/modules/FloorModal.vue'
import AreaModal from '@/views/chooseSeat/BaseData/Venue/modules/AreaModal.vue'
import ImageView from '@/views/chooseSeat/ImageView/ImageView.vue'





export default {
  name: "SeatAssignForm",
  mixins: [JeecgListMixin],
  components: {
    PersonSelectedModal,
    PersonModal,
    ActivityModal,
    VenueInfoModal,
    FloorModal,
    AreaModal,
    ImageView
  },
  inject: ['operation'],

  data() {
    return {


      loadding: false,
      activeKey: '',
      active: '',
      status: 1,
      // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      selected: [],//被选元素的索引
      itemsData: [], //存储所有dom
      fromvenue: this.from === "VenueList",//是否来自场馆的调用
      selectedSeatIds: [],//選中座位ids
      movable: {
        dom: null,
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      myStyle: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      point: { //鼠标起点坐标
        start: { x: 0, y: 0 },//鼠标终点坐标
        end: { x: 0, y: 0 },//是否正在move
        moving: false,//获取范围内四个角的坐标
      },

      drawervisible: false,
      rowdisabled: false,
      coldisabled: false,
      FloorAreaList: [],
      maxRowQty: 0,//行
      maxColQty: 0,//列
      sysfloorData: [],//當前楼层
      sysareaData: [],//當前区域
      sysareaid: '',//默认区域
      sysfloorid: '',//默认樓層
      subset: [],//status  0  可选座位   (白色)1  已选座位   (绿色) 2  已购票座位 (红色) 3空座
      venueInfo: [],
      bordersize: '2px solid ',

      curentRowColNo: 0,
      contextMenuDataRow: {
        menuName: 'Row1',
        axis: {
          x: null,
          y: null
        },
        // Menu options (菜单选项)
        menulists: [
          { btnName: '插入整排', fnHandler: 'addrow' },
          { btnName: '刪除整排', fnHandler: 'delrow' }]
      },
      contextMenuDataCol: {
        menuName: 'Col1',
        axis: {
          x: null,
          y: null
        },
        // Menu options (菜单选项)
        menulists: [
          { btnName: '插入整列', fnHandler: 'addcol' },
          { btnName: '刪除整列', fnHandler: 'delcol' }]
      },
      contextMenuDataSignal: {
        menuName: 'Signal1',
        axis: {
          x: null,
          y: null
        },
        // Menu options (菜单选项)
        menulists: [
          { btnName: '手動選座', fnHandler: 'ManualRank', icoName: "fa fa-home fa-fw" },
          { btnName: '取消選座', fnHandler: 'CancelRank', icoName: "fa fa-home fa-fw" },
          { btnName: '鎖定座位', fnHandler: 'LockRank', icoName: "fa fa-home fa-fw" },
          { btnName: '解鎖座位', fnHandler: 'UnlockRank', icoName: "fa fa-home fa-fw" },
          { btnName: '設定佔位', fnHandler: 'OccupyRank', icoName: "fa fa-home fa-fw" }
        ]

      },

      selectedseats: [],
      selectedperson: '',
      assign_rule: '1',
      description: '座位分配信息',
      record: {},
      dataSource_person_seat: [],
      dataSource_person_info: [],
      dataSource_person_info_top: [],//前30條
      allDataZ: [],
      treePageSize: 30,// 加载条数--可自定义
      scrollPage: 1,
      from: 'SeatAssignForm',
      totalPerson: '',
      totalSeats: '',
      noAssignPersons: '',
      updatetime: '',
      personModalVisible: false,
      assignruleModalVisible: false,
      operationtype: '',

      isSeatList: [{ label: "Y", value: "Y" }, { label: "N", value: "N" }],

      assignruleList: [{ key: "1", name: "從上到下，從左到右邊" },
      { key: "2", name: "從上到下，從右到左邊" },
      { key: "3", name: "從下到上，從左到右邊" },
      { key: "4", name: "從下到上，從右到左邊" }
      ],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',


      },
      // 表头

      url: {
        list: "/ActivityInfo/AutoRank",
        AutoRank: "/ActivityInfo/AutoRank",
        OneClear: "/ActivityInfo/OneClear",
        ManualRank: "/ActivityInfo/ManualRank",
        CancelRank: "/ActivityInfo/CancelRank",
        OccupyRank: "/ActivityInfo/OccupyRank",
        LockRank: "/ActivityInfo/LockRank",
        UnlockRank: "/ActivityInfo/UnlockRank",
        SwapRank: "/ActivityInfo/SwapRank",
        getSeatPersonStatistics: "/ActivitySeat/GetSeatPersonStatistics",
        getActivityDataStatistics: "/ActivityInfo/getActivityDataStatistics",
        getPersonInfo: "/PersonInfo/getActivityPerson",
        delete: "/PersonInfo/delete",

        setseat: "/VenueSeat/SetSeats",
        setactivityseat: "/ActivitySeat/SetSeats",
        deletefloor: "/VenueFLoor/deleteData",
        deleteactivityfloor: "/ActivityFLoor/deleteData",
        deletearea: "/VenueArea/deleteData",
        deleteactivityarea: "/ActivityArea/deleteData",
        addrowcol: "/VenueInfo/AddRowColData",
        delrowcol: "/VenueInfo/DelRowColData",
        getvenueseat: "/VenueInfo/SeatInfoList",
        getactivityseat: "/ActivityArea/SeatInfoList",
      },
    }
  },

  created() {

  },
  mounted() {

  },

  watch: {
    movable: {
      handler(newValue, oldValue) {// 数组发生变化时的处理逻辑
        this.myStyle.height = newValue.height
        this.myStyle.width = newValue.width
        this.myStyle.top = newValue.top
        this.myStyle.left = newValue.left
        //console.log('数组发生了变化1',newValue);
        //console.log('数组发生了变化2',oldValue);
      }, deep: true // 深度监听数组的变化
    }, //   监听属性对象，newValue为新的值，也就是改变后的值
    visible(newValue) {
      if (newValue) {
        //菜单显示的时候
        // document.body.addEventListener，document.body.removeEventListener它们都接受3个参数
        // ("事件名" , "事件处理函数" , "布尔值");
        // 在body上添加事件处理程序
        document.body.addEventListener("click", this.closeMenu);
      } else {
        //菜单隐藏的时候
        // 移除body上添加的事件处理程序
        document.body.removeEventListener("click", this.closeMenu);
      }
    },

  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    personNoAssign() {
      return this.dataSource_person_info_top.map(({ sysid, pname, jobname, deptname }) => ({ value: sysid, label: pname + ' ' + jobname?jobname:'' + ' ' + deptname?deptname:'' }));
    },
    columns() {
      if (this.language) {
        return [
          //座位分组名称
          {
            title: this.language['cs.sgroupname'],
            align: "left",
            ellipsis: true,
            width: 100,
            dataIndex: 'sgroupname'
          },
          //已選座位數
          {
            title: this.language['cs.checkseatqty'],
            ellipsis: true,
            width: 100,
            align: "left",
            dataIndex: 'checkseatqty',
            scopedSlots: { customRender: 'action' },
          },
          //未選座位數
          {
            title: this.language['cs.notcheckseatqty'],
            align: "left",
            ellipsis: true,
            dataIndex: 'notcheckseatqty',
            width: 100
            // customRender: (t, r, index) => {
            //   return this.filterListText(this.selectDataAreaCodeList, t, 'value')
            // }
          },
          //座位總數
          {
            title: this.language['cs.seat.seattotalqty'],
            width: 100,
            align: "left",
            dataIndex: 'seattotalqty',
            ellipsis: true

          },
        ]
      }
    },
    columns_person_info() {
      if (this.language) {
        return [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: this.language['cs.person.personid'],
            align: "left",
            width: 120,
            dataIndex: 'personid',

          },
          {
            title: this.language['cs.person.pname'],
            align: "left",
            dataIndex: 'pname',

          },
          {
            title: this.language['cs.person.seatstatus'],
            align: "center",
            width: 80,
            dataIndex: 'isseat',

          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 120,
            scopedSlots: { customRender: 'action_person' },
          }
        ]
      }
    }
  },
  methods: {

    loadData() {
      // this.getSeatPersonStatistics();
      this.getSeatAssignData();
      this.getPersoninfo();
      this.getActivityDataStatistics()
    },
    //一鍵排位
    handleAutoRank() {
      var that = this;

      that.confirmLoading = true;
      // this.$confirm({
      //   title: "确认一鍵排位",
      //   content: "是否一鍵排位?",
      //   onOk: function () {
      //     that.assignruleModalVisible = true;
      //   }
      // });
      that.assignruleModalVisible = true;
    },

    AutoRank() {
      var that = this;

      postAction(that.url.AutoRank, { sysactivityid: that.operation.sysactivityid, sysvenueid: that.operation.sysvenueid, ruleno: that.assign_rule }).then((res) => {
        if (res.status) {
          that.$message.success(res.message);
          that.getSeatAssignData();
          that.assignruleModalVisible = false;
          that.loadData();

        } else {
          that.$message.warning(res.message);
        }
      }).finally(() => {
        that.confirmLoading = false;
      })

    },
    //一鍵清除
    handleOneClear() {
      var that = this;
      that.confirmLoading = true;
      this.$confirm({
        title: "确认一鍵清除",
        content: "是否一鍵清除?",
        onOk: function () {
          postAction(that.url.OneClear, { sysactivityid: that.operation.sysactivityid, sysvenueid: that.operation.sysvenueid }).then((res) => {
            if (res.status) {
              that.$message.success(res.message);
              that.getSeatAssignData();
              that.loadData();

            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }
      })
    },

    //手動选位
    handleManualRank() {
      var that = this;

      if (!that.selectedseats || that.selectedseats.length < 1) {
        that.$message.error("請選擇座位");
        return;
      }
      this.selectedperson = '',
        this.operationtype = 'ManualRank',
        // this.getPersoninfo();
        this.personModalVisible = true;

    },
    ManualRank() {
      var that = this;
      if (!that.selectedperson) {
        that.$message.error("請選擇人員");
        return;
      }
      postAction(that.url.ManualRank, { sysactivityid: that.operation.sysactivityid, sysseatid: that.selectedseats[0].sysseatid, syspersonid: that.selectedperson }).then((res) => {
        if (res.status) {
          that.$message.success(res.message);
          that.getSeatAssignData();
          that.loadData();

        } else {
          that.$message.warning(res.message);
        }
      }).finally(() => {
        that.confirmLoading = false;
      })
    },
    //取消選座
    handleCancelRank() {
      var that = this;
      if (!that.selectedseats || that.selectedseats.length < 1) {
        that.$message.error("請選擇座位");
        return;
      }
      that.confirmLoading = true;
      var seats = that.selectedseats.map((item) => { return item.sysseatid }).join(',')
      this.$confirm({
        title: "确认取消選座",
        content: "是否取消選座?",
        onOk: function () {
          postAction(that.url.CancelRank, { sysactivityid: that.operation.sysactivityid, sysseatids: seats }).then((res) => {
            if (res.status) {
              that.$message.success(res.message);
              that.getSeatAssignData();
              that.loadData();

            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }
      })
    },
    //佔位
    handleOccupyRank() {
      var that = this;
      if (!that.selectedseats || that.selectedseats.length < 1) {
        that.$message.error("請選擇座位");
        return;
      }

      this.selectedperson = '',
        this.operationtype = 'OccupyRank',
        this.getPersoninfo({});
      this.personModalVisible = true;
    },
    OccupyRank() {
      var that = this;
      if (!that.selectedperson) {
        that.$message.error("請選擇人員");
        return;
      }
      var seats = that.selectedseats.map((item) => { return item.sysseatid }).join(',')
      postAction(that.url.OccupyRank, { sysactivityid: that.operation.sysactivityid, sysseatids: seats, syspersonid: that.selectedperson }).then((res) => {
        if (res.status) {
          that.$message.success(res.message);
          that.getSeatAssignData();
          that.loadData();

        } else {
          that.$message.warning(res.message);
        }
      }).finally(() => {
        that.confirmLoading = false;
      })
    },
    //鎖定座位
    handleLockRank() {
      var that = this;
      that.confirmLoading = true;
      if (!that.selectedseats || that.selectedseats.length < 1) {
        that.$message.error("請選擇座位");
        return;
      }
      var seats = that.selectedseats.map((item) => { return item.sysseatid }).join(',')
      this.$confirm({
        title: "确认鎖定座位",
        content: "是否鎖定座位?",
        onOk: function () {
          postAction(that.url.LockRank, { sysactivityid: that.operation.sysactivityid, sysseatids: seats }).then((res) => {
            if (res.status) {
              that.$message.success(res.message);
              that.getSeatAssignData();

            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }
      })
    },
    //釋放座位
    handleUnlockRank() {
      var that = this;
      that.confirmLoading = true;
      if (!that.selectedseats || that.selectedseats.length < 1) {
        that.$message.error("請選擇座位");
        return;
      }
      var seats = that.selectedseats.map((item) => { return item.sysseatid }).join(',')
      this.$confirm({
        title: "确认釋放座位",
        content: "是否釋放座位?",
        onOk: function () {
          postAction(that.url.UnlockRank, { sysactivityid: that.operation.sysactivityid, sysseatids: seats }).then((res) => {
            if (res.status) {
              that.$message.success(res.message);
              that.getSeatAssignData();

            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }
      })
    },
    //互換座位
    handleSwapRank() {
      var that = this;
      that.confirmLoading = true;
      if (!that.selectedseats || that.selectedseats.length != 2) {
        that.$message.error("必須選定兩個座位才能互換");
        return;
      }
      this.$confirm({
        title: "确认互換座位",
        content: "是否互換座位?",
        onOk: function () {
          postAction(that.url.SwapRank, {
            sysactivityid: that.operation.sysactivityid,
            oldsysseatid: that.selectedseats[0].sysseatid,
            newsysseatid: that.selectedseats[1].sysseatid,
            oldsyspersonid: that.selectedseats[0].syspersonid,
            newsyspersonid: that.selectedseats[1].syspersonid,
          }).then((res) => {
            if (res.status) {
              that.$message.success(res.message);
              that.getSeatAssignData();

            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }
      })
    },


    handleAddPerson() {
      this.$refs.modalForm.add();
    },
    handleEditActivity() {
      this.$refs.modalFormActivity.edit(this.operation.activityinfo);
    },
    handlePerson(selectedPerson) {

      this.operation.record = Object.assign({}, selectedPerson);

      this.$refs.personSelectedModal.edit();
    },

    searchQuery() {
      this.getPersoninfo(this.queryParam);
    },

    getActivityDataStatistics() {

      var that = this;
      getAction(that.url.getActivityDataStatistics, { sysactivityid: this.operation.sysactivityid, sysvenueid: this.operation.sysvenueid }).then((res) => {
        if (res.success) {
          that.totalPerson = res.result.totalPerson;
          that.totalSeats = res.result.totalSeats;
          that.noAssignPersons = res.result.noAssignPersons;
        } else {
          that.$message.warning(res.message);
        }
      }).finally(() => {
        // that.confirmLoading = false;
      })
    },
    getSeatPersonStatistics() {
      this.updatetime = new Date().toLocaleString();
      var that = this;
      getAction(that.url.getSeatPersonStatistics, { sysactivityid: this.operation.sysactivityid, sysvenueid: this.operation.sysvenueid }).then((res) => {
        if (res.success) {
          that.dataSource_person_seat = res.result;
        } else {
          that.$message.warning(res.message);
        }
      }).finally(() => {
        // that.confirmLoading = false;
      })
    },
    handlePersonDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error("请设置url.delete属性!")
        return
      }
      var that = this;
      deleteAction(that.url.delete, { id: id }).then((res) => {
        if (res.success) {
          //重新计算分页问题
          that.reCalculatePage(1)
          that.$message.success(res.message);
          that.getPersoninfo(this.queryParam);
          this.onClearSelected()
        } else {
          that.$message.warning(res.message);
        }
      });
    },

    modalFormOk() {
      this.getPersoninfo(this.queryParam);
    },
    getPersoninfo() {
      this.updatetime = new Date().toLocaleString();
      var that = this;
      getAction(that.url.getPersonInfo, { sysactivityid: that.operation.sysactivityid }).then((res) => {
        if (res.success) {
          that.dataSource_person_info = res.result;
          that.dataSource_person_info_top = res.result.slice(0, that.treePageSize);

        } else {
          that.$message.warning(res.message);
        }
      }).finally(() => {
        // that.confirmLoading = false;
      })
    },
    // 搜索的时候执行的方法，val就是输入的时候的内容
    handleSearch(val) {
      var that = this;
      if (!val) {
        that.getPersoninfo()
      } else {
        that.dataSource_person_info_top = []
        that.scrollPage = 1
        that.dataSource_person_info.forEach(item => {
          if (item.pname.indexOf(val) >= 0) {
            that.dataSource_person_info_top.push(item)
          }
        })
        that.allDataZ = that.dataSource_person_info_top;
        that.dataSource_person_info_top = that.dataSource_person_info_top.length < that.treePageSize ? that.dataSource_person_info_top : that.dataSource_person_info_top.slice(0, that.treePageSize) // 只渲染30条数据
      }
    },

    //下拉框下滑事件
    handlePopupScroll(e) {
      const { target } = e
      const scrollHeight = target.scrollHeight - target.scrollTop
      const clientHeight = target.clientHeight
      // 下拉框不下拉的时候
      if (scrollHeight === 0 && clientHeight === 0) {
        this.scrollPage = 1
        console.log(this.scrollPage)
      } else {
        // 当下拉框滚动条到达底部的时候
        if (scrollHeight < clientHeight + 5) {
          this.scrollPage = this.scrollPage + 1
          const scrollPage = this.scrollPage// 获取当前页
          const treePageSize = this.treePageSize * (scrollPage || 1)// 新增数据量
          const newData = [] // 存储新增数据
          let max = '' // max 为能展示的数据的最大条数
          if (this.dataSource_person_info.length > treePageSize) {
            // 如果总数据的条数大于需要展示的数据
            max = treePageSize
          } else {
            // 否则
            max = this.dataSource_person_info.length
          }
          // 判断是否有搜索
          if (this.valueData) {
            this.allDataZ.forEach((item, index) => {
              if (index < max) { // 当data数组的下标小于max时
                newData.push(item)
              }
            })
          } else {
            this.dataSource_person_info.forEach((item, index) => {
              if (index < max) { // 当data数组的下标小于max时
                newData.push(item)
              }
            })
          }

          this.dataSource_person_info_top = newData // 将新增的数据赋值到要显示的数组中
        }
      }
    },

    handlePersonFormOk() {
      if (this.operationtype === 'ManualRank') {
        this.ManualRank();
      }
      else if (this.operationtype === 'OccupyRank') {
        this.OccupyRank();
      }
      this.personModalVisible = false;
    },
    handleAssignruleFormOk() {

      this.AutoRank();
      this.personModalVisible = false;
    },
    handlePersonFormCancel() {
      this.personModalVisible = false;
    },
    handleAssignruleFormCancel() {
      this.assignruleModalVisible = false;
    },
    ExportXls() {
      let url = window._CONFIG['chooseSeatDomainURL'] + "/ActivityInfo/exportActivitySeatInfo?sysactivityid=" + this.operation.sysactivityid + "&sysvenueid=" + this.operation.sysvenueid
      downloadFile(url, 'SeatInfo.xlsx');

    },



    handleEditVenueInfo() {

      this.$refs.venueInfoModal.edit(this.operation.record);
    },

    handleEditFloorInfo() {
      this.$refs.floorModal.edit(this.sysfloorData);
    },


    handleAddFloorInfo() {
      this.$refs.floorModal.sysactivityid = this.operation.sysactivityid;
      this.$refs.floorModal.sysvenueid = this.operation.sysvenueid;
      this.$refs.floorModal.add();

    },
    handleDeleteFloorInfo() {
      var that = this;
      this.$confirm({
        title: "删除樓層",
        content: "是否刪除樓層",
        onOk: function () {
          let deletefloor_url = that.fromvenue ? that.url.deletefloor : that.url.deleteactivityfloor;
          httpAction(deletefloor_url, that.sysfloorData, "post").then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.loadData();
            }
            else {
              that.$message.errors(res.message);
            }
          }
          ).finally(() => {

          });
        }
      })
    },
    handleAddAreaInfo() {
      this.$refs.areaModal.sysactivityid = this.operation.sysactivityid;
      this.$refs.areaModal.sysvenueid = this.operation.sysvenueid;
      this.$refs.areaModal.sysfloorid = this.sysfloorData.sysfloorid;
      this.$refs.areaModal.add();

    },
    //编辑区域
    handleEditAreaInfo() {
      this.$refs.areaModal.edit(this.sysareaData);
    },
    //刪除区域
    handleDeleteAreaInfo() {
      var that = this;
      this.$confirm({
        title: "删除區域",
        content: "是否刪除當前選中區域",
        onOk: function () {
          let deletearea_url = that.fromvenue ? that.url.deletearea : that.url.deleteactivityarea;
          httpAction(deletearea_url, that.sysareaData, "post").then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.loadData();
            }
            else {
              that.$message.errors(res.message);
            }
          }
          ).finally(() => {

          });
        }
      })
    },

    getSeatAssignData(sysactivityid = this.operation.sysactivityid, sysvenueid = this.operation.sysvenueid) {
      var that = this;
      that.subset = [];
      that.selectedSeatIds = [];
      that.selected = [];
      that.itemsData = [];
      //加载默认楼层信息
      let selectvenue = {
        sysactivityid: sysactivityid,
        sysvenueid: sysvenueid
      };
      getAction('/ActivityInfo/seatAssignDetail', { sysvenueid, sysactivityid }).then((res) => {
        if (res.success) {

          let floor = [];
          that.FloorAreaList = res.result.records;
          floor = res.result.records.find((item) => item.sysfloorid === that.sysfloorData.sysfloorid);
          //如果當前樓層在更新後的數據中找不到就取默認樓層
          if (!floor) {
            floor = res.result.records[0];
          }
          that.sysfloorData = floor;//設置當前樓層
          let sysareaid = that.sysareaData ? that.sysareaData.sysareaid : "";
          // that.$refs.imageview.viewimage(that.sysfloorData.allfiles);
          if (floor) {
            let area = floor.children.find((item) => item.sysareaid === sysareaid)
            if (!area) {
              area = floor.children[0];//当前区域
            }
            that.sysareaData = area;//当前区域

            that.activeKey = that.sysfloorData.sysfloorid;
            that.sysfloorid = that.sysfloorData.sysfloorid;
            that.active = that.sysareaData.sysareaid;
            that.sysareaid = that.sysareaData.sysareaid;

            //取默认行列
            that.maxRowQty = that.sysareaData.maxRowQty;//行
            that.maxColQty = that.sysareaData.maxColQty;//列
            //查询默认楼层座位
            that.selectAreaSeatData();
          }

        }
      })
    },

    handleClickTab(key) { //楼层选择
      let list = this.FloorAreaList.filter(item => item.sysfloorid == key)
      if (list.length > 0) {
        this.sysfloorData = list[0];
        this.activeKey = key
        this.sysfloorid = key
        if (list[0].children.length > 0) {
          this.sysareaid = list[0].children[0].sysareaid;
          this.active = list[0].children[0].sysareaid;
          this.selectAreaSeatData();
        }
      }
    },
    // 綁定區域數據
    selectAreaSeatData() {
      var that = this;
      that.selectedSeatIds = [];
      that.selected = [];
      that.itemsData = [];
      that.subset = [];
      that.active = that.sysareaid;
      that.sysareaData = that.sysfloorData.children.find((item) => item.sysareaid === that.sysareaid);
      that.maxRowQty = that.sysareaData.maxRowQty;
      that.maxColQty = that.sysareaData.maxColQty;
      let selectparams = {
        sysactivityid: this.operation.sysactivityid,
        sysvenueid: this.operation.sysvenueid,
        sysareaId: this.sysareaid
      };
      let url = "";
      if (this.from === 'VenueList') {
        url = '/SelectData/VenueSeatInfoList';
      }
      //座位分配
      else {

        url = '/SelectData/ActivitySeatInfoList';
      }
      getAction(url, selectparams).then((res) => {
        if (res.success) {

          // console.log("綁定區域數據",res.result.records)
          that.subset = dataProces(that.sysfloorData.children, res.result.records);
          that.$nextTick(() => {
            let seats = that.$refs[`seats_${that.sysfloorid}`] ? that.$refs[`seats_${that.sysfloorid}`] : []
            console.log("seat===", seats);
            if (seats && seats.length > 0) {
              for (let i = 0, l = seats.length; i < l; i++) {
                that.itemsData[i] = {
                  selected: false,
                  dom: seats[i]
                }
              }
            }
          })
        }
      })
    },
    handleRadioChange(val) { //区域选择
      var that = this;
      that.sysareaid = val.target.value;
      this.selectAreaSeatData();
    },
    handleRadioStatusChange(val) { //座位状态选择
      var that = this;
      that.status = val.target.value;
      that.model.status = val.target.value;
    },
    seatSelection(id, data) { //座位选择
      let prdata = this.subset
      prdata[id].forEach((item, index) => {
        if (item.sysid == data) {
          prdata[id][index].status = prdata[id][index].status === '1' ? '0' : '1';
        }
      });
      /*********座位选择接口更新数据库处理 star**************/


      /*********座位选择接口更新数据库处理 end**************/
    },
    getSelectedSteats() {
      var that = this;
      that.selectedseats = [];
      let selectedDoms = that.itemsData.filter((item) => item.selected == true);

      selectedDoms.forEach((item) => {
        that.subset.forEach((row) => {
          let seat = row.find((seat) => seat.sysseatid == item.dom.id);
          if (seat) {
            that.selectedseats.push(seat);

            console.log('座位：' + seat.colno + ',' + seat.rowno);
          }
        }
        )
      })
    },
    //新增列
    handleAddCol() {
      var that = this;
      var params = { type: "col", rowcolno: that.maxColQty + 1, sysareaid: that.sysareaid, sysactivityid: that.operation.sysactivityid };

      this.$confirm({
        title: "新增列",
        content: "是否新增列",
        onOk: function () {
          httpAction(that.url.addrowcol, params, "post").then((res) => {
            if (res.success) {
              that.$message.success(res.message);

              that.loadData();
            }
            else {
              that.$message.errors(res.message);
            }
          }
          ).finally(() => {

          });
        }
      })
    },
    //新增行
    handleAddRow() {
      var that = this;
      var params = { type: "row", rowcolno: that.maxRowQty + 1, sysareaid: that.sysareaid, sysactivityid: that.operation.sysactivityid };

      this.$confirm({
        title: "新增排",
        content: "是否新增排",
        onOk: function () {
          httpAction(that.url.addrowcol, params, "post").then((res) => {
            if (res.success) {
              that.$message.success(res.message);

              that.loadData();
            }
            else {
              that.$message.errors(res.message);
            }
          }
          ).finally(() => {

          });
        }
      })
    },


    clickData(type, rowno, colno) {
      this.selected = []; //清空被选的索引
      this.selectedSeatIds = [];
      this.drawervisible = true;
      if (type == "rows") {
        for (var i = 0; i < rowno; i++) {

          let selectIndex = 0;
          selectIndex = i * this.maxColQty + colno

          this.itemsData.forEach((item, index) => {
            if (index == selectIndex) {
              this.selectedSeatIds.push(item.dom.id);
              this.selected.push(selectIndex + 1);
              item.selected = true;
            }
          })
        }

      }

      if (type == "cols") {
        for (var i = 0; i < colno; i++) {
          let selectIndex = 0;
          selectIndex = rowno * this.maxColQty + i
          this.itemsData.forEach((item, index) => {
            if (index == selectIndex) {
              this.selectedSeatIds.push(item.dom.id);
              this.selected.push(selectIndex + 1);
              item.selected = true;
            }
          })
        }
      }
      this.getSelectedSteats();
    },
    onClose() {
      this.drawervisible = false
    },
    getPosition() {
      let angle = []; //角
      angle.push(this.point.start); //起点
      angle.push(this.point.end); //终点
      angle.push({
        x: this.point.end.x,
        y: this.point.start.y
      }); //对角
      angle.push({
        x: this.point.start.x,
        y: this.point.end.y
      }); //对角
      return angle;
    },
    //判断元素是否满足被选中的条件
    isSelected(rect) {
      let angle = this.getPosition(); //获取四个角的坐标

      //获取指定图形的四个坐标
      let rectangle = [
        {
          x: rect.x,
          y: rect.y
        },
        {
          x: rect.x + rect.width,
          y: rect.y + rect.height
        },
        {
          x: rect.x + rect.width,
          y: rect.y
        },
        {
          x: rect.x,
          y: rect.y + rect.height
        }
      ];

      //满足以下任意一个条件即可
      //互相判断
      for (let pos of rectangle) {
        if (pos.x > angle[0].x &&
          pos.x < angle[1].x &&
          pos.y > angle[0].y &&
          pos.y < angle[1].y) {
          return true;
        }
      }
      //互相判断
      for (let pos of angle) {
        if (pos.x > rectangle[0].x &&
          pos.x < rectangle[1].x &&
          pos.y > rectangle[0].y &&
          pos.y < rectangle[1].y) {
          return true;
        }
      }
      //相交检测（横）
      if (angle[0].x < rectangle[0].x &&
        angle[1].x > rectangle[1].x &&
        angle[0].y > rectangle[0].y &&
        angle[1].y < rectangle[1].y) {
        return true;
      }
      //相交检测（竖）
      if (angle[0].x > rectangle[0].x &&
        angle[1].x < rectangle[1].x &&
        angle[0].y < rectangle[0].y &&
        angle[1].y > rectangle[1].y) {
        return true;
      }
      return false;
    },

    down(e) {//鼠标按下,记录初始点击的位置
      //console.log('鼠标按下:',e);
      if (e.button != 0) { return; }
      this.point.start.x = e.x;
      this.point.start.y = e.y;
      //同步选择框的原点
      this.movable.left = e.x + "px";
      this.movable.top = e.y + "px";
      this.point.moving = true; //标记移动开始
      //console.log('鼠标按下:',this.movable);
    },
    move(e) {// 鼠标移动
      // console.log('鼠标移动:',e);
      if (!this.point.moving) return;
      let { x, y } = e; //鼠标位置 //同步放大元素
      this.movable.height = Math.abs(this.point.start.y - y) + "px";
      this.movable.width = Math.abs(this.point.start.x - x) + "px";
      // console.log('鼠标移动:',this.movable);
    },
    upan(e) {//没有移动，直接终止
      //console.log('没有移动，直接终止:',e);
      if (e.button != 0) { return; }
      if (!this.point.moving) return;
      this.movable.width = 0;
      this.movable.height = 0;
      this.point.end.x = e.x;
      this.point.end.y = e.y;
      this.point.moving = false; //循环遍历元素是否被选中
      this.selected = []; //清空被选的索引
      this.selectedSeatIds = [];

      this.itemsData.filter((item) => item.selected == true).forEach((item) => { item.selected = false });//清空歷史選中數據


      this.itemsData.forEach((item, index) => {

        if (this.isSelected(item.dom.getBoundingClientRect())) {
          this.selected.push(index + 1);
          this.selectedSeatIds.push(item.dom.id);
          item.selected = true;
        }
      });
      this.getSelectedSteats();
      console.log('选的索引 :', this.selected);

    },

    handleClick(item) {
      var titleMsg = "插入列", contentMsg = "是否插入列", type = "";
      var that = this;
      var params;
      let url = that.url.addrowcol;
      // 执行对应的操作
      if (item == "addrow") {
        titleMsg = "插入排";
        contentMsg = "是否插入排";
        type = "row";
      }
      else if (item == "addcol") {
        titleMsg = "插入列";
        contentMsg = "是否插入列";
        type = "col";
      }
      else if (item == "delrow") {
        titleMsg = "刪除排";
        contentMsg = "是否刪除排";
        type = "row";
        url = that.url.delrowcol;
      }
      else {
        titleMsg = "刪除列";
        contentMsg = "是否刪除列";
        type = "col";
        url = that.url.delrowcol;

      }
      params = { type: type, rowcolno: that.curentRowColNo + 1, sysareaid: that.sysareaid, sysactivityid: that.operation.sysactivityid };
      this.$confirm({
        title: titleMsg,
        content: contentMsg,
        onOk: function () {
          httpAction(url, params, "post").then((res) => {
            if (res.success) {
              that.$message.success(res.message);

              that.loadData();
            }
            else {
              that.$message.errors(res.message);
            }
          }
          ).finally(() => {

          });
        }
      })
    },
    handleContextMenu(event, curentRowColNo, type) {
      event.preventDefault();
      var x = event.clientX; //这个应该是相对于整个浏览器页面的x坐标，左上角为坐标原点（0,0）
      var y = event.clientY; //这个应该是相对于整个浏览器页面的y坐标，左上角为坐标原点（0,0）
      var intY = 0;
      if (this.from === 'VenueList') {
        intY = 180;
      }
      else {
        intY = 230;
      }
      // const bodyWidth = document.documentElement.clientWidth
      // const maxLeft = bodyWidth - 200
      // var x = event.pageX <= maxLeft ? event.pageX : maxLeft
      // var y = event.pageY
      this.top = y - intY;
      this.left = x;
      this.selectedSeatIds = [];
      this.selected = [];
      if (type == "row") {
        this.items = this.itemsrow
        for (var i = 0; i < this.maxColQty; i++) {
          let selectIndex = 0;
          selectIndex = (curentRowColNo - 1) * this.maxColQty + i
          this.itemsData.forEach((item, index) => {
            if (index == selectIndex) {
              this.selectedSeatIds.push(item.dom.id);
              this.selected.push(selectIndex + 1);
              item.selected = true;
            }
          })
        }
      }
      else {
        this.items = this.itemscol
        for (var i = 0; i < this.maxRowQty; i++) {

          let selectIndex = 0;
          selectIndex = i * this.maxColQty + (curentRowColNo - 1)

          this.itemsData.forEach((item, index) => {
            if (index == selectIndex) {
              this.selectedSeatIds.push(item.dom.id);
              this.selected.push(selectIndex + 1);
              item.selected = true;
            }
          })
        }

      }


      this.visible = true; //显示菜单
      this.curentRowColNo = curentRowColNo;

    },
    //关闭菜单
    closeMenu() {
      this.visible = false;
    },
    showMenuRow(curentRowColNo, type) {
      event.preventDefault()
      var x = event.clientX
      var y = event.clientY
      // Get the current location
      this.contextMenuDataRow.axis = {
        x, y
      }
      this.selectedSeatIds = [];
      this.selected = [];

      for (var i = 0; i < this.maxColQty; i++) {
        let selectIndex = 0;
        selectIndex = (curentRowColNo - 1) * this.maxColQty + i
        this.itemsData.forEach((item, index) => {
          if (index == selectIndex) {
            this.selectedSeatIds.push(item.dom.id);
            this.selected.push(selectIndex + 1);
            item.selected = true;
          }
        })
      }
      this.curentRowColNo = curentRowColNo;
    },
    showMenuCol(curentRowColNo, type) {
      event.preventDefault()
      var x = event.clientX
      var y = event.clientY
      // Get the current location
      this.contextMenuDataCol.axis = {
        x, y
      }
      this.selectedSeatIds = [];
      this.selected = [];
      for (var i = 0; i < this.maxRowQty; i++) {

        let selectIndex = 0;
        selectIndex = i * this.maxColQty + (curentRowColNo - 1)

        this.itemsData.forEach((item, index) => {
          if (index == selectIndex) {
            this.selectedSeatIds.push(item.dom.id);
            this.selected.push(selectIndex + 1);
            item.selected = true;
          }
        })
      }
      this.curentRowColNo = curentRowColNo;
    },
    addrow() {
      this.handleClick('addrow')
    },
    addcol() {
      this.handleClick('addcol')
    },
    delrow() {
      this.handleClick('delrow')
    },
    delcol() {
      this.handleClick('delcol')
    },
    handleClick(item) {
      var titleMsg = "插入列", contentMsg = "是否插入列", type = "";
      var that = this;
      var params;
      let url = that.url.addrowcol;
      let rowcolno = 0;
      // 执行对应的操作
      if (item == "addrow") {
        titleMsg = "插入排";
        contentMsg = "是否插入排";
        type = "row";
        rowcolno = that.curentRowColNo + 1;
      }
      else if (item == "addcol") {
        titleMsg = "插入列";
        contentMsg = "是否插入列";
        type = "col";
        rowcolno = that.curentRowColNo + 1;
      }
      else if (item == "delrow") {
        titleMsg = "刪除排";
        contentMsg = "是否刪除排";
        type = "row";
        url = that.url.delrowcol;
        rowcolno = that.curentRowColNo;
      }
      else {
        titleMsg = "刪除列";
        contentMsg = "是否刪除列";
        type = "col";
        url = that.url.delrowcol;
        rowcolno = that.curentRowColNo;

      }
      params = { type: type, rowcolno: rowcolno, sysareaid: that.sysareaid, sysactivityid: that.operation.sysactivityid };
      this.$confirm({
        title: titleMsg,
        content: contentMsg,
        onOk: function () {
          httpAction(url, params, "post").then((res) => {
            if (res.success) {
              that.$message.success(res.message);

              that.loadData();
            }
            else {
              that.$message.errors(res.message);
            }
          }
          ).finally(() => {

          });
        }
      })
    },
    showMenuSignal(sysseatid) {
      event.preventDefault()
      var x = event.clientX
      var y = event.clientY
      // Get the current location
      this.contextMenuDataSignal.axis = {
        x, y
      }
      console.log(" this.contextMenuDataSignal==", this.contextMenuDataSignal);
    },


  }

}
</script>


<style scoped>
.current-settings {
  display: inline-block;
}

.current-background {
  display: inline-block;
}

.main {
  float: left;
  width: 100%;
  min-height: 650px;
  overflow: scroll;
  background: #fff;
  margin-top: 50px;
}

.main-content {
  float: left;
  min-height: 450px;
}

.list {
  float: left;
  width: 100%;
  margin-left: 6px;
  display: flex;
}

.oplist {
  float: left;
  height: 30px;
  margin-bottom: 5px;
}

.selection {
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdcdc;
  text-align: center;
  line-height: 30px;
  width: 60px;
  height: 30px;
  background: #F2F2F2;
  margin: 0px;
}

.red {
  background: #f00;
  /* color: #fff; */
}

.green {
  background: #11df0dd9;
  /* color: #fff; */
}

.yellow {
  background: #FACD91;
  /* color: #fff; */
}

.emptyseat {
  background: #fff;
  display: flex;
  flex-direction: column;
  border: 1px solid #fff;
  width: 60px;
  height: 30px;
  margin: 0px;
  margin-right: 5px;
}

.select-hbody {
  display: flex;
  float: left;
  width: 100%;
}

.tdbody-line {
  float: left;
  margin-left: 71px;
  margin-bottom: 10px;
  display: flex;
}

.tdbody-coln {
  width: 65px;
  display: flex;
  float: left;
  flex-direction: column;
}

.colno {
  float: left;
  width: 60px;
  height: 30px;
  margin-right: 5px;
  border: 1px solid #dcdcdc;
  background: #EBFAF0;
  /* color: #fff; */
  text-align: center;
  line-height: 30px;
}

.rowno {
  position: relative;
  width: 60px;
  height: 30px;
  margin-bottom: 5px;
  border: 1px solid #dcdcdc;
  background: #FFF9E6;
  /* color: #fff; */
  text-align: center;
  line-height: 30px;
}

.select-area {
  float: left;
  width: 92%;
  /* border: 1px solid #000000; */
  /* display: flex; */
  /* align-items: center; */
  /* flex-wrap: wrap; */
  /* justify-content: center; */
  /* position: relative;
  overflow: hidden; */
}

.select-area .item {
  display: inline-block;
  width: 60px;
  height: 30px;
  margin-right: 5px;
  text-align: center;
  /* background: #dcdcdc; */
  border: 1px solid #dcdcdc;
  user-select: none;
}

.select-area .selected {
  background-color: #81D3F8;
}

.select-area .move {
  position: fixed;
  top: 100px;
  left: 200px;
  width: 80px;
  height: 100px;
  background: rgba(234, 23, 135, 0.3);
}

/* .context-menu {
  position: absolute;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  list-style: none;
  margin: 0;
  padding: 0;
  z-index: 100;
}
.context-menu li {
  padding: 8px 16px;
  cursor: pointer;
}
.context-menu li:hover {
  background-color: #ddd;
} */
/* * {
  margin: 0;
  padding: 0;
} */

:deep(.vue-contextmenu-listWrapper .context-menu-list) {
  line-height: 40px !important;
}

:deep(.btn-wrapper-simple) {
  display: inline-block;
  line-height: 40px;
}

:deep(.nav-name-right) {
  margin: 2px;
}

/* :deep(.ant-modal-body){
  padding:2px!important;
}  */
</style>